import api from "@/services/api";
import { get } from "lodash";

// Tracking nunca pode derrubar o salvamento: a apresentacao ja foi gravada na
// API quando o evento sai, e uma excecao aqui perderia o retorno para a tela.
function track(eventName, props = {}) {
  (async () => {
    try {
      const { trackEvent } = await import("@/services/posthog");
      trackEvent(eventName, props);
    } catch (_) {
      /* posthog optional */
    }
  })();
}

function buildBaseUrl(rootState) {
  const label =
    localStorage.getItem("label") ||
    get(rootState, "company.company.label") ||
    "";
  return `/api/v1/talent/${label}/user/talent/presentation`;
}

export default {
  async fetch({ commit, rootState }) {
    commit("SET_LOADING", true);
    try {
      const { data } = await api.get(buildBaseUrl(rootState));
      const payload = (data && data.data) || {};
      commit("SET_AUDIO", payload.audio || null);
      commit("SET_VIDEO", payload.video || null);
    } catch (error) {
      console.error(error);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async saveAudio({ commit, rootState }, file) {
    const fd = new FormData();
    fd.append("file", file, file.name || "presentation.webm");

    const { data } = await api.post(`${buildBaseUrl(rootState)}/audio`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    const audio = get(data, "data", null);
    commit("SET_AUDIO", audio);

    track("profile_audio_saved", {
      media_id: get(audio, "id", null),
      url: get(audio, "url", null),
      mime_type: get(audio, "mime_type", null),
      has_transcription: get(audio, "has_transcription", false),
    });

    return audio;
  },

  async deleteAudio({ commit, rootState }) {
    await api.delete(`${buildBaseUrl(rootState)}/audio`);
    commit("SET_AUDIO", null);
  },

  async saveVideo({ commit, rootState }, url) {
    const { data } = await api.post(`${buildBaseUrl(rootState)}/video`, {
      url,
    });
    const video = get(data, "data", null);
    commit("SET_VIDEO", video);

    track("profile_video_saved", {
      video_id: get(video, "id", null),
      // source_url e o que o talento colou; embed_url e o que a tela toca.
      url: get(video, "source_url", null) || url,
      embed_url: get(video, "embed_url", null),
      provider: get(video, "provider", null),
      duration_seconds: get(video, "duration_seconds", null),
    });

    return video;
  },

  async deleteVideo({ commit, rootState }) {
    await api.delete(`${buildBaseUrl(rootState)}/video`);
    commit("SET_VIDEO", null);
  },

  clear({ commit }) {
    commit("CLEAR");
  },
};
